import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { downgradeInjectable } from '@angular/upgrade/static'
import { Shipment } from '@tradecafe/types/core'
import { AngularCopy } from 'src/decorators/angular-copy.decorator'
import { AngularParams, HaveAngularParams } from 'src/decorators/angular-params.decorator'
import { environment } from 'src/environments/environment'


const { apiUrl } = environment


export default module =>
  module.service('ShipmentApi', downgradeInjectable(ShipmentApiService))


@Injectable()
@AngularCopy()
export class ShipmentApiService {
  private http = inject(HttpClient)


  @HaveAngularParams()
  list(@AngularParams() params) {
    return this.http.get<{ data: Shipment[] }>(`${apiUrl}/shipments`, { params }).toPromise()
  }

  listByDealIds(params) {
    return this.http.post<{ data: Shipment[] }>(`${apiUrl}/shipments/by-deal-ids`, params).toPromise()
  }

  listByDeal(dealId: string) {
    return this.list({deals: dealId })
  }

  create(data: Partial<Shipment>) {
    return this.http.post<{ data: Shipment }>(`${apiUrl}/shipments`, data).toPromise()
  }

  get(id: string) {
    return this.http.get<{ data: Shipment }>(`${apiUrl}/shipments/${id}`).toPromise()
  }

  update(id: string, data: Partial<Shipment>) {
    return this.http.put<{ data: Shipment }>(`${apiUrl}/shipments/${id}`, data).toPromise()
  }

  delete(id: string) {
    return this.http.delete<{ data: Shipment }>(`${apiUrl}/shipments/${id}`).toPromise()
  }

  track(containerNumber: string) {
    return this.http.get<{ data: any }>(`${apiUrl}/tracking/track/${containerNumber}`).toPromise()
  }
}
